import React from 'react';
import { css } from '@emotion/react';

import { breakpoints, paddingVariables } from '~/src/styles';

import { BuildYourRoutine } from './BuildYourRoutine';
import { stylesVariables } from './common-styles';
import { ConnectAndGrowWithTopInstructors } from './ConnectAndGrowWithTopInstructors';
import { CreateYouDialyRitual } from './CreateYouDialyRitual';
import { DocsAndFilms } from './DocsAndFilms';
import { FAQ } from './FAQ';
import { FeatureList } from './FeatureList';
import { HearFromOurCommunity } from './HearFromOurCommunity';
import { Hero } from './Hero';
import { MembershipIncludes } from './MembershipIncludes';
import { MembershipPlans } from './MembershipPlans';
import { TheYiDifference } from './TheYiDifference';
import { YogaPractices } from './YogaPractices';

const styles = {
  container: css(
    stylesVariables,
    {
      '--Border-Radius': '20px',
      '--Section-Padding': paddingVariables.p56,
      '--Heading-Padding': paddingVariables.p16,
      '--SubHeading-Padding': paddingVariables.p32,
      '--Content-Padding': paddingVariables.p40,
      [breakpoints.minTablet]: {
        '--Border-Radius': '30px',
        '--Section-Padding': paddingVariables.p80,
        '--Heading-Padding': paddingVariables.p24,
        '--SubHeading-Padding': paddingVariables.p40,
      },
      [breakpoints.minDesktop]: {
        '--Border-Radius': '40px',
        '--Section-Padding': paddingVariables.p120,
        '--SubHeading-Padding': paddingVariables.p64,
        '--Content-Padding': paddingVariables.p80,
      },
    },
    { background: 'var(--Pure-White,#fff)' },
  ),
};

export const HomepageLoggedOutPage: React.FC = () => {
  return (
    <div css={styles.container}>
      <Hero />
      <CreateYouDialyRitual />
      <FeatureList />
      <YogaPractices />
      <DocsAndFilms />
      <MembershipIncludes />
      <TheYiDifference />
      <ConnectAndGrowWithTopInstructors />
      <BuildYourRoutine />
      <HearFromOurCommunity />
      <MembershipPlans />
      <FAQ />
    </div>
  );
};
